// fw Skeleton — loading placeholder lines. aria-busy so a screen reader
// knows the region is filling in rather than empty.

import React from 'react';
import './Skeleton.css';

export function Skeleton({ lines = 3, className = '', ...rest }) {
  const n = Math.max(1, Math.floor(Number(lines) || 1));
  return (
    <div className={['fw-skeleton', className].filter(Boolean).join(' ')} aria-busy="true" aria-live="polite" {...rest}>
      {Array.from({ length: n }, (_, i) => (
        <div key={i} className="fw-skeleton__line" />
      ))}
    </div>
  );
}

export default Skeleton;
